import { useEffect, useState } from 'react'

import { Box, Divider, Grid, Typography } from '@material-ui/core'
import CircularProgress from '@material-ui/core/CircularProgress'
import config from 'config'
import { format } from 'date-fns'
import { es } from 'date-fns/locale'
import { useLocation } from 'react-router-dom'
import { getUbicacion } from 'service/helpers/localstorage'
import { interfaces } from 'service/interfaces'

import styles from '../styles'

const getWeatherIconPath = (symbolCode = 'cloudy') => `/Images/weather-icons/${symbolCode}.svg`

const Weather = () => {
  const [clima, setClima] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')

  const location = getUbicacion() || ''

  const { pathname } = useLocation()
  const classes = styles()
  const isOemLocation = (pathname && pathname.includes('oem')) || location.includes('OEM')
  const weatherConfig = isOemLocation ? config.weather.oem : config.weather.eco

  useEffect(() => {
    const getWeather = async () => {
      setLoading(true)
      setError('')
      try {
        const res = await interfaces.dashboardInterface.weather(weatherConfig)
        if (!res.data?.current || !res.data?.daily?.[0] || !res.data?.daily?.[1]) {
          throw new Error('Respuesta de clima incompleta')
        }
        setClima(res.data)
      } catch (_error) {
        setClima(null)
        setError('No se pudo obtener el clima en este momento.')
      } finally {
        setLoading(false)
      }
    }
    getWeather()
    // eslint-disable-next-line
  }, [weatherConfig.lat, weatherConfig.lon, weatherConfig.timeZone])

  const day = new Date()
  const day2 = new Date(day)
  day2.setDate(day.getDate() + 1)
  const day3 = new Date(day)
  day3.setDate(day.getDate() + 2)

  const tomorrow = clima?.daily?.[0]
  const dayAfterTomorrow = clima?.daily?.[1]

  return (
    <div>
      <>
        {loading ? (
          <div className={classes.heightContentSpinner}>
            <CircularProgress size={70} color="primary" />
          </div>
        ) : error ? (
          <div className={classes.heightContentSpinner}>
            <Box p={3} textAlign="center">
              <Typography color="error" variant="body2">
                {error}
              </Typography>
            </Box>
          </div>
        ) : (
          <Grid container className={classes.weatherContainer}>
            <Grid item sm={8} xs={8} className={classes.currentDay}>
              <Typography align="center" variant="h6" style={{ textTransform: 'capitalize' }}>
                {format(day, "eeee, d 'de' MMMM", { locale: es })}
              </Typography>
              <Box fontSize="fontSize" m={1} fontFamily="fontFamily">
                {weatherConfig.label}
              </Box>
              <img
                className={classes.mainWeatherIcon}
                alt={clima.current.description}
                src={getWeatherIconPath(clima.current.symbolCode)}
              />
              <Typography style={{ textTransform: 'capitalize' }} variant="h6">
                {clima.current.description}
              </Typography>

              <Box m={1} fontFamily="fontFamily" fontSize="h4.fontSize" fontWeight="fontWeightBold">
                {Math.round(clima.current.temp)}
                {'°C'}
              </Box>
            </Grid>

            <Grid item sm={4} xs={4} color="primary" className={classes.weatherForecastColumn}>
              <div className={classes.weatherColor}>
                <div className={classes.weatherForecastDay}>
                  <Typography align="center" className={classes.colorLetter} variant="body1">
                    {format(day2, 'd MMMM', { locale: es })}
                  </Typography>
                  <img
                    className={classes.forecastWeatherIcon}
                    alt={tomorrow.description}
                    src={getWeatherIconPath(tomorrow.symbolCode)}
                  />
                  <Typography align="center" className={classes.colorLetter}>
                    {Math.round(tomorrow.min)} / {Math.round(tomorrow.max)}
                    {'°C'}
                  </Typography>
                </div>
                <Divider className={classes.forecastDivider} />
                <div className={classes.weatherForecastDay}>
                  <Typography align="center" className={classes.colorLetter}>
                    {format(day3, 'd MMMM', { locale: es })}
                  </Typography>
                  <img
                    className={classes.forecastWeatherIcon}
                    alt={dayAfterTomorrow.description}
                    src={getWeatherIconPath(dayAfterTomorrow.symbolCode)}
                  />
                  <Typography align="center" className={classes.colorLetter}>
                    {Math.round(dayAfterTomorrow.min)} / {Math.round(dayAfterTomorrow.max)}
                    {'°C'}
                  </Typography>
                </div>
              </div>
            </Grid>
          </Grid>
        )}
      </>
    </div>
  )
}

export default Weather
